/**
 * NotFoundAlert
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'react-bootstrap';
import Main from 'components/PageLayout/Main/index.jsx';
import messages from './messages.js';

function NotFound() {
  return (
    <Main width="640px" shaded>
      <Alert variant="danger" className="alert-shaded">
        <FormattedMessage {...messages.header} />
      </Alert>
    </Main>
  );
}

export default NotFound;
